export const OkPrestoModeDefintions = [
  {
    value: 'clip',
    details: 'Xirgocam will create a 20-second video clip starting from 10 seconds before the spoken keyword and going until 10 seconds after'
  },
  {
    value: 'marker',
    details: 'Xirgocam will create thumbnail(s) when the keyword is detected. No videos will be created with this clip'
  }
]